"use strict";

angular.module('PatientApp').factory('FeedbackService', function (VuexStore) {
  return {
    getOptions: function getOptions() {
      return VuexStore.dispatch('getFeedbackOptions');
    },
    updateScore: function updateScore(paymentId, score, id) {
      return VuexStore.dispatch('updateFeedbackScore', {
        paymentId: paymentId,
        score: score,
        id: id
      });
    },
    updateAll: function updateAll(id, paymentId, score, comment, reasons) {
      return VuexStore.dispatch('updateFeedback', {
        id: id,
        paymentId: paymentId,
        score: score,
        comment: comment,
        reasons: reasons
      });
    }
  };
});